"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Shift = void 0;
/***
 * Performs a bitwise shift on 1 bit. EX: Shift(1) === 1 << 1 === '1 0' === 2
 * @param {number} bits
 * @returns {number}
 * @constructor
 */
const Shift = (bits) => 2 ** bits;
exports.Shift = Shift;
